import { useRef, useState } from "react";
import { Tooltip } from "@fluentui/react-components";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import { ExportHistoricalData, getStafferProjectTracker, getStafferProjectTrackerMemberDetails, handleExportGroupedPower, mapPowerExportData, mapPowerMemberData, projectTrackerNewExportBankers, projectTrackerNewExportDeals, sortMembersByRoleAndCapacity, sortProjectsByStatus } from "../dashboard-pui-banker/power-banker-time-log/power-banker-helper";
import DownloadHistoricalDataModal from "./download-historical-data-modal";

const DashboardPowerProjectTrackerHeader = ({ projects, members, user, resetDataState, dealState, }) => {
    const _dealLogExport = useRef(null);
    const _juniorBankersExport = useRef(null);

    const sortedProjects = sortProjectsByStatus(projects);
    const transformedProjects = mapPowerExportData(sortedProjects);
    const transformedMembers = mapPowerMemberData(members);

    const bankers = projects?.map(item => item.MemberDetails.map(b => ({ ...b, ProjectId: item.ProjectId, ProjectName: item.ProjectName, ClientName: item.ClientName }))).flat() || [];
    const sortedBankers = sortMembersByRoleAndCapacity(bankers);
    const hasAnyFilter =
        dealState.filter &&
        Array.isArray(dealState.filter.filters) &&
        dealState.filter.filters.length > 0;
    const canReset = dealState.sort.length > 0 || hasAnyFilter;
    const [viewDataModal, setViewDataModal] = useState(false);
    const history = useHistory();
    const canCreate = user?.currentUser?.privileges?.["Projects"]?.Add ?? false;
    
    return (
        <>
            <div className="widget-header" data-testid="header">
                <div className="header-left">
                    <div className="main-title-badge-row">
                        <div className="main-title">Project Tracker</div>
                    </div>
                    <div className="sub-title">GIB/PU&I</div>
                </div>
                <div className="header-right">
                    <Tooltip content="Reset Filters and Sorting">
                        <FluentButton
                            appearance="secondaryWithOutline"
                            icon={
                                <FluentUiIcon
                                    name="ArrowResetRegular"
                                    color={canReset ? "#0F6CBD" : "#A0A0A0"}
                                    size={20}
                                    disabled={!canReset}
                                />
                            }
                            disabled={!canReset}
                            onClick={resetDataState}
                        />
                    </Tooltip>
                    {projects?.length > 0 &&
                        <Tooltip content="Export Data">
                            <FluentButton
                                appearance="secondaryWithOutline"
                                icon={
                                    <FluentUiIcon
                                        name="ArrowDownloadRegular"
                                        color="#0F6CBD"
                                        size={20}
                                    />
                                }
                                onClick={() =>
                                    handleExportGroupedPower({ projects: transformedProjects, members: transformedMembers, projectColumnsGrouped: projectTrackerNewExportDeals(), memberColumnsGrouped: projectTrackerNewExportBankers() })
                                }
                            />
                        </Tooltip>
                    }
                    <FluentButton
                        icon={<FluentUiIcon name={'CalendarArrowCounterclockwiseRegular'} color={'#0F6CBD'} size={20} />}
                        text="Historical Data"
                        onClick={() => setViewDataModal(true)}
                    />
                    <FluentButton
                        text="Create Project"
                        appearance="secondaryWithOutline"
                        disabled={!canCreate}
                        icon={
                            <FluentUiIcon
                                name="FolderAddRegular"
                                color={canCreate ? "#0F6CBD" : "#A0A0A0"}
                                size={20}
                            />
                        }
                        onClick={() => {
                            if (canCreate) {
                                history.push({
                                    pathname: "/projects/create",
                                    state: { fromDashboard: true },
                                });
                            }
                        }}
                    />
                </div>
            </div>
            <ExcelExport data={transformedProjects} ref={_dealLogExport}>
                {getStafferProjectTracker()}
            </ExcelExport>
            <ExcelExport data={sortedBankers} ref={_juniorBankersExport}>
                {getStafferProjectTrackerMemberDetails()}
            </ExcelExport>
            {viewDataModal &&
                <DownloadHistoricalDataModal
                    open={viewDataModal}
                    OnCancel={() => setViewDataModal(false)}
                    OnDownloadData={(startDate, endDate) =>
                        ExportHistoricalData(startDate, endDate)
                    }
                />
            }
        </>
    );
};

DashboardPowerProjectTrackerHeader.propTypes = {
    projects: PropTypes.array,
    user: PropTypes.object,
    resetDataState: PropTypes.func,
    dealState: PropTypes.object,
};

export default DashboardPowerProjectTrackerHeader;